var chunkToChildrenMap = {
	"1540": [
		1169
	],
	"1994": [
		8714,
		1498
	],
	"2119": [
		1169,
		2898
	],
	"2791": [
		3658
	],
	"4210": [
		8315
	],
	"6591": [
		2412
	],
	"7360": [
		8714
	],
	"8944": [
		3286
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));